import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherTemp from "./WeatherTemp";
import "./App.css";

export default function CurrentTemp(props){

    return(
        <div className="row topSpace currentTemp">
                <div className="col-8">
                   <img src={props.data.icon} alt="placeholder"></img>
                    <h1>In {props.data.city} the weather is {props.data.description} today</h1>
                    <p><FormattedDate time={props.data.time}/></p>
                </div>
                <WeatherTemp celsius={props.data.temperature} humidity={props.data.humidity} wind={props.data.wind}/>
            </div>
    )

}